import React from "react";
export const Header = () => {
  return (
    <div>
      <h2>Expense Tracker</h2>
    </div>
  );
};

